import type { ConnectionStatus } from "../lib/aide-protocol";

const LABELS: Record<ConnectionStatus, string> = {
  idle: "Idle",
  connecting: "Connecting…",
  open: "Connected",
  closed: "Reconnecting…",
  error: "Connection issue",
};

const DOT_COLOR: Record<ConnectionStatus, string> = {
  idle: "bg-(--color-ink-faint)",
  connecting: "bg-(--color-accent-coral) animate-pulse",
  open: "bg-emerald-400",
  closed: "bg-(--color-accent-coral) animate-pulse",
  error: "bg-red-400",
};

export function ConnectionPill({ status }: { status: ConnectionStatus }) {
  return (
    <span
      role="status"
      aria-live="polite"
      className="flex items-center gap-1.5 rounded-(--radius-pill) bg-(--color-canvas-elev) px-2.5 py-1 text-[11px] text-(--color-ink-muted)"
    >
      <span aria-hidden="true" className={`h-1.5 w-1.5 rounded-full ${DOT_COLOR[status]}`} />
      {LABELS[status]}
    </span>
  );
}
